"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.highlightGrammar = exports.grammar = void 0;
exports.grammar = `
{{
  function getOperation(op) {
    switch (op) {
      case "==":
        return "EQ"
      case "?=":
        return "CONTAINS"
      case "&&":
        return "AND"
      case "||":
        return "OR"
    }
  }
}}

Expression
  = _ head:Condition tail:(_ ("&&" / "||") _ Condition)* _
  {
    let result;
    
     if (tail.length) {
      let operation = getOperation(tail[0][1]);

      result = {
        operation,
          filters: [
            head,
          ]
      }
            
      for (let i = 0; i < tail.length; i++) {
        if (operation !== getOperation(tail[i][1])) {
            error('Cannot have both AND / OR operations in single expression, use "(", ")" to prioritize.')
        }
        result.filters.push(tail[i][3])
      }
        
      return result;
    }
    
    return {
      ...head
    }
  }

Condition
  = "(" expr:Expression ")" { return expr; } / Filter
  
Filter
  = field:Field _ operation:("==" / "?=") _ value:Value
  {
    return { field, operation: getOperation(operation), value }
  }

Field "field"
  = [abcdefghijklmnopqrstuvxyzABCDEFGHIJKLMNOUQRSTUVWXYZáčďéěíňóřšťúůýžÁČĎÉĚÍŇÓŘŠŤÚÝŽ\\.\\/ ]i* { return text(); }

Value "value"
  = [abcdefghijklmnopqrstuvxyzABCDEFGHIJKLMNOUQRSTUVWXYZáčďéěíňóřšťúůýžÁČĎÉĚÍŇÓŘŠŤÚÝŽ0-9\\.\\/\\- ]i* { return text(); }


_ "whitespace"
  = [ \\\t\\\n\\\r]*
`;
/**
 * Backup
 */
// Field "field"
//   = _ [a-z\\.\\/ ]i+ { return text().trim(); }
// Value "value"
//   = _ [a-z0-9\\.\\/ ]i+ { return text().trim(); }
exports.highlightGrammar = `
{{
  function getResult(op) {
    let operation = op[1] ?? op[0];
    
    if ([" ", "\\\n", "\\\r", "\\\t"].includes(operation) || operation === "AND") {
      return {
        field: "text",
        operation: "INTERVALS_ALL_OF",
        maxGaps: -1,
        ordered: false,
      } 
    } else if (operation === "OR") {
      return {
        field: "text",
        operation: "INTERVALS_ANY_OF",
      }
    } else if (operation === "SENTENCE") {
      return {
        field: "text",
        operation: "INTERVALS_ALL_OF",
        filter: {
          kind: "NotContaining",
          filter: {
            operation: "INTERVALS_MATCH",
            field: "text",
            query: "<DOT>",
            analyzer: "keyword",
            ordered: false
          }
        },
        maxGaps: -1,
        ordered: false
      }
    } else if (operation === "PARAGRAPH") {
      return {
        field: "text",
        operation: "INTERVALS_ALL_OF",
        filter: {
          kind: "NotContaining",
          filter: {
            operation: "INTERVALS_MATCH",
            field: "text",
            query: "<NEWLINE>",
            analyzer: "keyword",
            ordered: false
          }
        },
        maxGaps: -1,
        ordered: false
      }
    } else if (typeof operation === 'object' && operation[0] === "NEAR(") {
      const regex = /NEAR\\\((\\\d+)\\\)/;
      const match = operation.flat().join("").match(regex);
      
      return {
        field: "text",
        operation: "INTERVALS_ALL_OF",
        maxGaps: parseInt(match[1]),
        ordered: false,
      }
    }
  }
}}

Expression
  = QuotedValue / UnaryExpression / BinaryExpression / Value

UnaryExpression
  = _ head:UnaryOperator tail:Value _
  { 
    return {
      operation: "QUERY_STRING",
      fields: {
        text: 1.0
      },
      value: \`NOT \${tail.query}\`,
      defaultOperator: "AND",
    };
  }

BinaryExpression
  = _ head:Value tail:(BinaryOperator Value)* _
  {
    let result;
    
    if (tail.length) {
      result = getResult(tail[0][0]);

      result = {
        ...result,
        intervals: [
          head,
        ]
      }

      for (let i = 0; i < tail.length; i++) {
        if (result.operation !== getResult(tail[i][0]).operation) {
            error('Cannot have multiple operations in single expression.')
        }
        result.intervals.push(tail[i][1])
      }

      return result;
    }

    return {
      ...head
    }
  }
  
UnaryOperator
  = (_"NOT"_)
  
BinaryOperator
  = (_"AND"_ / _"OR"_ / _"SENTENCE"_ / _"PARAGRAPH"_ / _("NEAR("[0-9]+")")_ / [ \\\t\\\n\\\r]+)

QuotedValue "quoted value"
  = '"' phrase:[^"]+ '"'
  {
  	const value = phrase.join("");
    
    return {
      operation: "QUERY_STRING",
      fields: {
        text: 1.0
      },
      value: \`\"\${value}\"\`,
      defaultOperator: "AND",
    }
  }

Value "value"
  = [abcdefghijklmnopqrstuvxyzABCDEFGHIJKLMNOPQRSTUVWXYZáčďéěíňóřšťúůýžÁČĎÉĚÍŇÓŘŠŤÚÝŽ0-9\\.\\/\\-\\*]i*
  {
    const value = text();
    
    if (value.includes("*")) {
      return {
        operation: "INTERVALS_WILDCARD",
        field: "text",
        pattern: value,
        analyzer: "keyword",
      }
    }
    
    return { field: "text", operation: "INTERVALS_MATCH", query: value }
  }

_ "whitespace"
  = [ \\\t\\\n\\\r]*
`;
//# sourceMappingURL=grammar.js.map